<template>
  <v-card-text>
    <v-layout column>
      <v-layout row wrap>
        <v-flex xs12 sm6="sm6">
          <h3 class="font-weight-regular mb-3">Store Information</h3>
          <div>
            <span class="mr-1">{{ $t("labels.businessName") }}:</span>
            <span class="font-weight-medium">{{ Store.businessName }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.phoneNumber") }}:</span>
            <span class="font-weight-medium">{{ Store.phoneNumber }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.address") }}:</span>
            <span class="font-weight-medium">{{ Store.address }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.city") }}:</span>
            <span class="font-weight-medium">{{ Store.city }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.state") }}:</span>
            <span class="font-weight-medium">{{ Store.state }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.zipCode") }}:</span>
            <span class="font-weight-medium">{{ Store.zipcode }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.country") }}:</span>
            <span class="font-weight-medium">{{ Store.country }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6="sm6">
          <h3 class="font-weight-regular mb-3">Software Plan</h3>
          <div>
            <span class="mr-1">{{ $t("labels.selectedPlan") }}:</span>
            <span class="font-weight-medium"> Monthly Plan</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.selectedPlan") }}:</span>
            <span class="font-weight-medium" v-if="plans.package === 1"> Build Your Own</span>
            <span class="font-weight-medium" v-else>Full Package</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.subscriptionFee") }}:</span>
            <span class="font-weight-medium">{{ plans.softwareFee | currency }}</span>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm6="sm6">
          <h3 class="font-weight-regular mb-3">Card Information</h3>
          <div>
            <span class="mr-1">{{ $t("labels.nameOnCard") }}:</span>
            <span class="font-weight-medium"> {{ Card.nameOnCard }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.cardNumber") }}:</span>
            <span class="font-weight-medium" v-if="Card.cardNumber"
              >XXXXXXXXXXXX{{ Card.cardNumber.substring(Card.cardNumber.length - 4) }}</span
            >
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.expiryDate") }}:</span>
            <span class="font-weight-medium">{{ Card.cardExpiry }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.cvvCode") }}:</span>
            <span class="font-weight-medium">{{ Card.cvvCode }}</span>
          </div>
        </v-flex>
        <v-flex xs12 sm6="sm6">
          <h3 class="font-weight-regular mb-3">Card Address</h3>
          <div>
            <span class="mr-1">{{ $t("labels.address") }}:</span>
            <span class="font-weight-medium"> {{ Card.address }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.city") }}:</span>
            <span class="font-weight-medium">{{ Card.city }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.state") }}:</span>
            <span class="font-weight-medium">{{ Card.state }}</span>
          </div>
          <div>
            <span class="mr-1">{{ $t("labels.zipCode") }}:</span>
            <span class="font-weight-medium">{{ Card.zipcode }}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout class="mt-3" row>
      <v-checkbox v-model="Review.terms">
        <div slot="label">
          I agree CellSmart
          <v-tooltip class="mr-1 ml-1" bottom="bottom">
            <a
              slot="activator"
              target="_blank"
              href="https://www.cellsmartpos.com/termsandcondition/"
              >terms and condition</a
            >Opens in new window
          </v-tooltip>
        </div>
      </v-checkbox>
    </v-layout>
  </v-card-text>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState("location", ["Store", "Review", "Card", "plans"]),
    ...mapGetters("location", ["plans"])
  }
};
</script>

<style scoped></style>
